import React, { Fragment, useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ReactComponent as CancelIcon } from '../../Assets/Icons/cancel.svg';
import { useSingleProperty } from '../../Services/hooks/SingleProperty';
import { useSelector } from 'react-redux';
import { RootState } from '../../Storeredux/reducers/rootReducer';
import { userData } from '../../Storeredux/constants/actionTypes';
import { ReactComponent as UserIcon } from '../../Assets/Icons/usernamicon.svg';
import { ReactComponent as EmailIcon } from '../../Assets/Icons/Emailiconwhite.svg';
import { ReactComponent as PhoneIcon } from '../../Assets/Icons/phoneicon.svg';

interface Props {
  isOpen: boolean;
  onHide: () => void;
  amount: string;
  propertyId: string
  getFrameLink: (id: string) => void;
}

function RentAssist({ isOpen, onHide, amount, propertyId, getFrameLink }: Props) {
  const UserState = useSelector((state: RootState) => state.user as userData);
  const { user } = UserState;
  const [data, setData] = useState({
    name: '',
    email: '',
    phone_number: '',
    amount: '',
    terms: false,
  });
  // const { loading } = useLandingPage();
  const { requestAssist, loading } = useSingleProperty();
  const [errorState, setErrorState] = useState({
    phone: '',
    bvn: '',
  });
  const validatePhoneNumber = (phoneNumber: string) => {
    console.log('validate', phoneNumber);
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    const expectedLength = 11;
    if (digitsOnly.length === expectedLength) {
      setData({ ...data, phone_number: phoneNumber });
      setErrorState({ ...errorState, phone: '' });
    } else {
      // setData({ ...data, phone: '' });
      setErrorState({ ...errorState, phone: 'Invalid Phone Number' });
    }
  };
  const onChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
    if (e.target.name === 'phone_number') {
      console.log(e.target.value);
      validatePhoneNumber(e.target.value);
      return;
    }
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const areAllKeysFilled = (obj: any) => {
    for (const key in obj) {
      // eslint-disable-next-line no-prototype-builtins
      const value = obj.hasOwnProperty(key);
      if (value) {
        if (!obj[key]) {
          return false;
        }
      }
    }
    return true;
  };
  const isFormComplete = areAllKeysFilled(data);
  const onSubmit = async (e: any) => {

    e.preventDefault();
    if (errorState.phone) {
      setErrorState({ ...errorState, bvn: 'Please enter a valid phone number' });
    } else if (isFormComplete) {
      const payload = {
        user_id: user.id,
        property_id: propertyId,
      };
      const res = await requestAssist(payload);
      if (res.success) {
        getFrameLink(res.link);
        onHide();
        return;
      }

    } else {
      setErrorState({ ...errorState, bvn: 'Please complete the form information' });
    }

  };
  console.log(user);
  useEffect(() => {
    if (user) {
      setData({
        name: user.name || '',
        email: user.email || '',
        phone_number: user.phone || '',
        amount: amount,
        terms: false,
      });
    }
  }, []);
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onHide}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className="w-full transform overflow-hidden lg:max-w-[55%] xl:max-w-[35%] rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                <div className="flex justify-between px-4 py-4" style={{ boxShadow: '0px 2px 8px 2px #8C8C8C1A' }}>
                  <h1 className={'font-bold text-xl pb-1.5'}>Rent Assist Details</h1>

                  <CancelIcon onClick={onHide} className="cursor-pointer" />
                </div>
                <div className="justify-center p-7 lg:p-10 lg:pt-7 pt-.5">
                  <form className={'w-full flex flex-col gap-y-2'} onSubmit={onSubmit}>
                    <div className="pb-3">
                      <div className="relative">
                        <UserIcon
                          className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                        <input autoComplete="off" name="name" value={data.name} onChange={onChange} required
                               className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-lg"
                               type="text" placeholder="name" />
                      </div>
                    </div>
                    <div className="pb-3">
                      <div className="relative">
                        <EmailIcon
                          className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                        <input autoComplete="off" name="email" value={data.email} onChange={onChange} required
                               className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-lg"
                               type="text" placeholder="Email" />
                      </div>
                    </div>
                    <div className="pb-3">
                      <div className="relative">
                        <PhoneIcon
                          className="absolute w-4 h-4 text-gray-500 left-2 top-1/2 transform -translate-y-1/2" />
                        <input autoComplete="off" name="phone" value={data.phone_number} onChange={onChange} required
                               className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-lg"
                               type="text" placeholder="Phone" />
                      </div>
                    </div>
                    <div className="pb-3">
                      <div className="relative">
                        <input autoComplete="off" name="amount" value={data.amount} onChange={onChange} required
                               className="focus-visible:outline-0 text-xs w-full p-2 pl-10 border border-input-color rounded-lg"
                               type="text" placeholder="Enter Rent Amount" />
                      </div>
                    </div>

                    <div className={'rounded-lg bg-[#EEEEEE] py-2.5 px-2'}>
                      <p className={'text-sm'}>
                        I am agreeing that i have inspected the apartment and it met my preference.
                        I am obliged to pay 30% outrightly while the remaining payment will be deducted monthly by my
                        company.
                      </p>
                      <div className={'flex gap-2 my-2'}>
                        <input type='checkbox' checked={data.terms} onChange={() => setData({ ...data, terms: !data.terms })}  />
                        <label className={'text-xs font-bold'}>I confirm that I have read and accept the terms and conditions and privacy policy.</label>
                      </div>
                    </div>

                    <div className={'flex items-center gap-5 justify-end'}>
                      <p className={'text-custom-darkgreen font-bold'}>Cancel</p>
                      <button
                        className={`${isFormComplete ? 'bg-green-600' : 'bg-custom-grey'} flex justify-center self-center items-center h-fit rounded-custom border-0 text-white py-3.5 px-5`}>
                        {loading ? <div className="lds-spinner">
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div> : <div className={'font-bold px-3 flex flex-row'}>Send Request</div>
                        }
                      </button>
                    </div>


                  </form>
                </div>

              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
  ;
}

export default RentAssist;
